import { UserInfoResponse, Workspace } from "@storyboard/web-client/auth";
import { client as baseClient } from "@/config";

export const urlParamsFromWindowPathname = (workspaces: Workspace[]): string | null => {
  if (!workspaces || workspaces?.length === 0) {
    console.error("No valid workspaces provided.");
    return null;
  }
  const urlPath = window?.location?.pathname;
  const workspaceId = urlPath?.includes("/workspaces") ? urlPath?.split("/workspaces/")[1]?.split("/")[0] : null;
  const matchWorkspace = workspaces?.find((w) => w?.id === workspaceId);

  if (!workspaceId && workspaces?.length > 0) {
    return workspaces[0]?.id || null;
  } else if (matchWorkspace?.id) {
    return matchWorkspace?.id;
  } else if (workspaceId && !matchWorkspace) {
    console.error(`Workspace with ID ${workspaceId} not found in the provided workspaces.`);
    return null;
  }

  console.error("No valid workspaces provided.");
  return null;
};

export const fetchUser = async (): Promise<UserInfoResponse> => {
  try {
    return await baseClient.getUserInfo();
  } catch (e) {
    return Promise.reject(e);
  }
};
